import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllBrand = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/campaignbrand/all?clientId=${clientId}` : '/campaignbrand/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllBrandById = async (id?: number) => {
    const response = http.get(`/campaignbrand/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addBrand = async (data: any) => {
    const response = http.post(`/campaignbrand/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteBrand= async (data: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = http.post(`/campaignbrand/delete`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const activatedeactivate = async (data: any) => {
    const response = http.post(`/campaignbrand/deactivate`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateBrand = async (data: any) => {
    const response = http.put(`/campaignbrand/update`, data)
    return response;
}
